import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { MessageSquare } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { usePoll } from "@/hooks/usePoll";
import client from "@/lib/api";

export function FloatingMessages() {
  const { can, messagingEnabled } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [unread, setUnread] = useState(0);

  usePoll(async () => {
    if (!can("message.view") || !messagingEnabled) { setUnread(0); return; }
    try {
      const { data } = await client.get("/messages/conversations");
      const total = (data || [])
        .filter((c) => !c.oversight)
        .reduce((sum, c) => sum + (c.unread || 0), 0);
      setUnread(total);
    } catch { /* noop */ }
  }, 12000);

  if (!can("message.view") || !messagingEnabled || location.pathname === "/messages") return null;

  return (
    <button
      data-testid="floating-messages-btn"
      onClick={() => navigate("/messages")}
      title={unread > 0 ? `${unread} unread message${unread === 1 ? "" : "s"}` : "Messages"}
      className="fixed bottom-6 right-6 z-40 h-14 w-14 rounded-full bg-brand text-white shadow-lg shadow-brand/30 flex items-center justify-center hover:scale-105 hover:bg-brand-dark transition-transform"
    >
      <MessageSquare className="h-6 w-6" />
      {unread > 0 && (
        <span
          data-testid="floating-messages-badge"
          className="absolute -top-1 -right-1 min-w-[22px] h-[22px] px-1 rounded-full bg-red-500 text-white text-[11px] font-bold flex items-center justify-center border-2 border-white"
        >
          {unread > 99 ? "99+" : unread}
        </span>
      )}
    </button>
  );
}
